import React from "react";
import { Col, Modal, Row, Typography } from "antd";
import TextBox from "Pages/CommonControls/TextBox";

const { Title } = Typography;

interface IInvoiceCorrectionSummaryModalProps {
    isOpen: boolean;
    onOk: () => void;
    onCancel: () => void;
    isLoading: boolean;
    actions: string[];

    modifierName: string;
    onModifierNameChange: (value: string | null) => void;

    modificationReason: string;
    onModificationReasonChange: (value: string | null) => void;
}

export default function InvoiceCorrectionSummaryModal(props: IInvoiceCorrectionSummaryModalProps) {

    return (
        <Modal
            title="Módosítások"
            open={props.isOpen}
            onOk={props.onOk}
            confirmLoading={props.isLoading}
            onCancel={props.onCancel}
            cancelText="Mégsem"
            okText="Végrehajtás"
        >
            <Title level={5}>Audit információk</Title>
            <TextBox label="Módosító neve:" value={props.modifierName} onChange={props.onModifierNameChange} isRequired maxLength={256} />
            <TextBox label="Módosítás oka (nem kötelező):" value={props.modificationReason} onChange={props.onModificationReasonChange} multiline={3} maxLength={512} />

            <Title level={5}>Biztosan végrehajtja a következő műveleteket?</Title>

            <ul>
                {props.actions.map((a, i) => <li key={i}>{a}</li>)}
            </ul>

        </Modal >
    );
}